// @ts-nocheck
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { getLoginStatus } from "../../../../Utils/AuthCheck";

export default function First() {
  const navigate = useNavigate();
  const send_package = () => {
    if (getLoginStatus() === null || getLoginStatus() === false) {
      navigate("/login");
    } else {
      navigate("package_details");
    }
  };

  return (
    <section
      className="bg-homeSec1 bg-cover bg-center bg-no-repeat lg:py-72 sm:py-36 py-20 relative 
        before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black  
        before:bg-opacity-70"
    >
      <section className="md:w-4/5 sm:w-10/12 w-11/12 mx-auto flex flex-col items-center gap-y-7 relative text-center">
        <h1 className="font-bold lg:text-6xl sm:text-5xl text-4xl text-white">
          Shipping from China made easy!
        </h1>
        <p className="font-normal sm:text-base text-sm text-white text-opacity-80 xl:w-4/5">
          Pacifrica Express shipping services from China to anywhere in
          the world. Door-to-Door delivery by Air. At Pacifrica Express, we are
          committed to quality service to our customer. A state of the art
          tracking system is in place to track every consignment right from the
          collection point to the final destination.
        </p>
        <div className="flex sm:flex-row flex-col gap-x-2 gap-y-2">
          <button
            onClick={send_package}
            className="bg-themeRed text-white border border-themeRed hover:bg-transparent hover:text-white 
                hover:border-white flex items-center gap-x-2 font-medium text-xl px-8 py-2 rounded-md sm:w-auto w-full"
          >
            <FontAwesomeIcon icon={faPaperPlane} />
            <span>Send Package</span>
          </button>
          <Link to={`/getting_started`}>
            <button
              className="bg-transparent text-white border border-white hover:bg-white hover:text-black 
              font-medium text-xl px-8 py-2 rounded-md sm:w-auto w-full"
            >
              How it works
            </button>
          </Link>
        </div>
      </section>
    </section>
  );
}
